import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import localize from '@Components/localize';
import menuConfig from './menuConfig';
import {get_random_guid} from '@Helpers/OtherHelper';
import SuspenseLoader from '@Components/customComponents/SuspenseLoader';
import { Link } from 'react-router-dom';
import { linkTo } from '@Services/navigation';

class Main extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			...this.getStateMenu()
		};
	}

	getStateMenu = (boolean = false) => Object.fromEntries(Object.entries(menuConfig).filter(e => e[1]?.sub).map(e => [e[0], boolean]));

	slideMenu = (key) => {
		this.parseMenu({ [key]: !this.state[key] });
	};

	parseMenu = (menu) => {
		this.slideUpAllMenus(false);

		for (let el in this.state) {
			if (Object.keys(menu)[0] == el) {
				this.setState({
					[el]: !this.state[el]
				});

			}
		}
	};

	slideUpAllMenus = (boolValue) => {
		this.setState({
			...this.getStateMenu(boolValue)
		});
	};

	renderMenuVertical = () => Object.entries(menuConfig).map(item => {
		const { label, icon, link, pm} = item[1];
		const {permissions} = this.props;
		if (!pm(permissions)) return '';
		if (item[1]?.sub && Object.values(item[1]?.sub).length > 0) {
			const sub = () => Object.entries(item[1]?.sub).map(e => {
				const { label, link, pm} = e[1];
				if (!pm()) return '';

				return (
					<li key={get_random_guid()}>
						<Link
							to={linkTo(link)}
							className="menu-vertical__link-in flex--row_center-left"
							onClick={() => this.slideUpAllMenus(false)}
						>
							<span className="menu-vertical__text margin--left_30 color--white font--14">{label ?? ''}</span>
						</Link> 
					</li>
				)
			});

			return (
				<li className="menu-vertical__item" key={get_random_guid()}>
					<div className={`menu-vertical__link flex--row_center-left ${this.state?.[item[0]] ? 'selected--link' : ''}`} onClick={() => this.slideMenu(item[0])}>
						<span className="menu-vertical__icon margin--left_30">
							<i className={`icon-menu icon--${icon ?? 'user'}`}></i>
						</span>
						<span className="menu-vertical__text margin--left_10">
							{label ?? ''}
						</span>
					</div>
					<ul className={`menu-vertical__next ${this.state?.[item[0]] ? 'show--menu' : ''}`}>
						{sub()}
					</ul>
				</li>
			)
		}
		return (
			<li key={get_random_guid()} className="menu-vertical__item">
				<Link 
					to={link ? linkTo(link) : '#'}
					className="menu-vertical__link flex--row_center-left" 
					onClick={() => this.slideUpAllMenus(false)}
				>
					<span className="menu-vertical__icon margin--left_30">
						<i className={`icon-menu icon--${icon ?? 'user'}`}></i>
					</span>
					<span className="menu-vertical__text margin--left_10">
						{label ?? ''}
					</span>
				</Link>
			</li>
		)
	});

	render() {
		return(
			<React.Fragment>
				<div className="wrapper">
					<div className="wrapper__sidebar">
						<div className="logo logo--grey margin--auto margin--bottom_64"></div>
						<ul className="menu-vertical">
							{this.renderMenuVertical()}
						</ul>
					</div>
					<div className="wrapper__main-content">
						<Suspense fallback={<SuspenseLoader />}>
							{this.props.routesAuth}
						</Suspense>
						<div className="footer flex--row_center-end">
							<div className="footer__text font--14 color--grey_one font--noah_medium">
								© Options 2025 | All rights reserved
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

Main.propTypes = {
	routesAuth: PropTypes.object,
	permissions: PropTypes.array,
};

export default localize(Main);
